import React from "react";

const StarItem = () => {
  return <div style={{ color: "white" }}>StarItem lorem1afafafagsea </div>;
};

export default StarItem;
